import { applyMiddleware, combineReducers, createStore } from 'redux';
import { allOrders } from './allOrders';
import { commission } from './commission';
import { orders } from './orders';
import { price } from './price';
import { providers } from './providers';

import { aliexpress } from './aliexpress';
import { assemblies } from './assemblies';
import { beru } from './beru';
import { collections } from './collections';
import { detmir } from './detmir';
import { helpers } from './helpers';
import { insales } from './insales';
import { kaspi } from './kaspi';
import { mapMarkets } from './mapMarkets';
import { ozon } from './ozon';
import { ozonOrders } from './ozonOrders';
import { packaging } from './package';
import { postings } from './postings';
import { sbermarket } from './sbermarket';
import { staff } from './staff';
import { ui } from './ui';
import { user } from './user';
import { version } from './version';
import { wb } from './wb';
import { wbOrders } from './wbOrders';
import { yandex } from './yandex';

const store_name = 'bwh_2.0';

const logger = (store) => (next) => (action) => {
  let result;
  console.groupCollapsed('dispatching', action.type);
  console.log('prev state', store.getState());
  console.log('action', action);
  result = next(action);
  console.log('next state', store.getState());
  console.groupEnd();
  return result;
};

const saver = (store) => (next) => (action) => {
  let result = next(action);
  localStorage[store_name] = JSON.stringify(store.getState());
  return result;
};

const initStorage = (initialState = {}) => {
  if (localStorage.getItem(store_name) !== null) {
    return JSON.parse(localStorage.getItem(store_name));
  } else {
    localStorage.setItem(store_name, JSON.stringify(initialState));
    return initialState;
  }
};

export const storeFactory = (initialState = {}) =>

  createStore(combineReducers({
    version,
    price,
    orders,
    providers,
    allOrders,
    collections,
    user,
    staff,
    assemblies,
    ozon,
    wb,
    yandex,
    commission,
    beru,
    mapMarkets,
    ozonOrders,
    wbOrders,
    kaspi,
    aliexpress,
    ui,
    insales,
    postings,
    sbermarket,
    helpers,
    detmir,
    packaging,
  }),
    initStorage(initialState), applyMiddleware(logger, saver))



// applyMiddleware(logger, saver)(createStore)(
//   combineReducers({
//     price,
//     orders,
//     providers,
//     allOrders,
//     collections,
//     user,
//     staff,
//     assemblies,
//     ozon,
//     wb,
//     yandex,
//     commission,
//     beru,
//     mapMarkets,
//     ozonOrders,
//     wbOrders,
//     kaspi,
//     aliexpress,
//     ui,
//     insales,
//     postings,
//     sbermarket,
//     helpers,
//     detmir,
//     packaging,
//   }),
//   initStorage(initialState),
// );
